import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faDollarSign,
  faArrowTrendUp,
  faShoppingCart,
  faBullseye,
  faCalendar,
  faCreditCard,
} from '@fortawesome/free-solid-svg-icons';

export const METRIC_IDS = {
  GROSS_SALES: 'grossSales',
  NET_SALES: 'netSales',
  ORDER_COUNT: 'orderCount',
  AVERAGE_ORDER_VALUE: 'averageOrderValue',
  DAILY_AVERAGE: 'dailyAverage',
  CURRENCY: 'currency',
} as const;

export const METRIC_COLORS = {
  GROSS_SALES: '#10b981',
  NET_SALES: '#3b82f6',
  ORDER_COUNT: '#8b5cf6',
  AVERAGE_ORDER_VALUE: '#f59e0b',
  DAILY_AVERAGE: '#14b8a6',
  CURRENCY: '#06b6d4',
} as const;

export const METRIC_ICONS: Record<string, IconDefinition> = {
  [METRIC_IDS.GROSS_SALES]: faDollarSign,
  [METRIC_IDS.NET_SALES]: faArrowTrendUp,
  [METRIC_IDS.ORDER_COUNT]: faShoppingCart,
  [METRIC_IDS.AVERAGE_ORDER_VALUE]: faBullseye,
  [METRIC_IDS.DAILY_AVERAGE]: faCalendar,
  [METRIC_IDS.CURRENCY]: faCreditCard,
};

export const EMPTY_STATE_MESSAGES = {
  WEEKLY_BREAKDOWN: 'No weekly breakdown data available for this month.',
} as const;

export const REPORT_TYPE = {
  MONTHLY: 'monthly',
} as const;

export const MONTHS_TO_GENERATE = 12;

export const addCommasInPrices = (value: number | string): string => {
  return (parseFloat(String(value)) || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
